import { render, staticRenderFns } from "./WareHouse.vue?vue&type=template&id=3affa7a4&scoped=true&name=wareHouse&"
import script from "./WareHouse.vue?vue&type=script&lang=js&"
export * from "./WareHouse.vue?vue&type=script&lang=js&"
import style0 from "./WareHouse.vue?vue&type=style&index=0&id=3affa7a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3affa7a4",
  null
  
)

export default component.exports